import { render, staticRenderFns } from "./teachLock.vue?vue&type=template&id=393952be&scoped=true&"
import script from "./teachLock.vue?vue&type=script&lang=js&"
export * from "./teachLock.vue?vue&type=script&lang=js&"
import style0 from "./teachLock.vue?vue&type=style&index=0&id=393952be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393952be",
  null
  
)

export default component.exports